"use strict";

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBlackKey = isBlackKey;

var _etude = require("etude");

var Pitch = _etude.theory.Pitch;

function isBlackKey(pitch) {
  if (pitch == null) {
    throw new Error("Invalid pitch: ".concat(pitch));
  }

  return Pitch.fromProgramNumber(pitch.getProgramNumber()).orElseThrow(function () {
    return new Error("Invalid pitch: ".concat(pitch));
  }).getKey().getAccidental().map(function (a) {
    return a.getOffset();
  }).orElse(0) !== 0;
}